import React from 'react';
import { useContext, useState, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStopCircle } from '@fortawesome/free-solid-svg-icons'
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";

import QuizApi from '../QuizApi';
import quizInstanceAdminStatusContext from '../context/quizInstanceAdminStatusContext';

export default function QuizAdminEndBtn() {

  const ctx = useContext(quizInstanceAdminStatusContext);
	const [ending, setEnding] = useState(false);
	const endQuiz = useCallback(() => {

		const fn = async () => 
		{
			if (!ending)
			{
				setEnding(true);
				await QuizApi.quizInstanceEnd(ctx.quizInfo.id);
				setEnding(false);
			}
		};
		
		fn();

	}, [ctx, ending]);

  return (
		<Button type="submit" variant="quizSecondary" onClick={endQuiz}>
      {
        ending 
          ? <Spinner className="mr-2" size="sm" animation="border" /> 
          :<FontAwesomeIcon icon={faStopCircle} className="mr-2" />
      }
      Avsluta
		</Button>
  );
};